import React, { useState, useEffect, FC, useRef } from 'react';
import './activity-table-row.scss';
import { Checkbox } from 'primereact/checkbox';
import { Avatar } from 'primereact/avatar';
import { ContextMenu } from 'primereact/contextmenu';
import { Chip } from 'primereact/chip';
import { v4 as uuidv4 } from 'uuid';

export interface UserTableRowProps {
    username: string;
    shopName: string;
    name: string;
    action: string;
    created_at: string;
    checked: boolean;
    setChecked: (checked: boolean, id: string) => void;
    quantity: number;
}

const UserTableRow:FC<UserTableRowProps> = (props) => {
    const {username, shopName, name, action, created_at, checked, setChecked, quantity} = props;
    const cm = useRef(null);
    const quantityString = quantity ? quantity > 0 ? `+${quantity}` : quantity : 'N/A';
    return (
        <div className="activity-table-row" onContextMenu={(e) => cm.current.show(e)} key={uuidv4()}>
            <Checkbox onChange={e => setChecked(e.checked,username)} checked={checked}></Checkbox> 
            <div>
                {username}
            </div>
            <div>
                {shopName}
            </div>
            <div>
                {name}
            </div>  
            <div>
                {quantityString}
            </div>
            <div>
                {created_at}
            </div>
        </div>
    );
}
         
export default UserTableRow;